module.exports = __webpack_public_path__ + "img/p1.1c934c8a.png";